import { Tag } from 'antd'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DATE_FORMAT_CLIENT } from 'src/helpers/constants'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { useStore } from 'src/hooks'

interface ActiveFilterSummaryProps {
   // Bo loc dang ap dung (gia tri da gui len server): designTypeIds, productTypeIds, count, ...
   filter: any
}

// "1,2" -> ['1', '2']
const splitIds = (value: any) =>
   String(value || '')
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean)

// Doi danh sach id sang ten de doc; khong tim thay ten thi giu nguyen id
const namesOf = (ids: string[], list: any[], getName: (item: any) => string) =>
   ids.map((id) => {
      const found = (list || []).find((item: any) => String(item?.id) === id)
      return found ? getName(found) : id
   })

/**
 * Dong tom tat cac dieu kien dang loc (ngay tao, loai thiet ke, ...) de khoi phai mo lai popup Filter.
 * Khong loc gi thi khong hien.
 */
const ActiveFilterSummary: React.FC<ActiveFilterSummaryProps> = observer(({ filter }) => {
   const { t } = useTranslation()
   const CommonConfigStore = useStore('CommonConfigStore')
   const UserStore = useStore('UserStore')
   const { designTypesList, productTypesList } = CommonConfigStore
   const { listCreator, listDesigner, listApprover } = UserStore
   const userName = (user: any) => user?.name || user?.email

   const items: { label: string; value: string }[] = []

   const { fromDate, toDate } = filter || {}
   if (fromDate || toDate) {
      const from = fromDate ? moment(fromDate).format(DATE_FORMAT_CLIENT) : '...'
      const to = toDate ? moment(toDate).format(DATE_FORMAT_CLIENT) : '...'
      items.push({ label: t(GLOBAL_CLIENT.ngaytaoviec), value: `${from} → ${to}` })
   }

   const groups = [
      { key: 'designTypeIds', label: t(GLOBAL_CLIENT.designType), list: designTypesList, getName: (item: any) => item?.name },
      { key: 'productTypeIds', label: t(GLOBAL_CLIENT.productType), list: productTypesList, getName: (item: any) => item?.name },
      { key: 'count', label: t(GLOBAL_CLIENT.numberItems), list: [], getName: (item: any) => item?.name },
      { key: 'creatorIds', label: t(GLOBAL_CLIENT.creator), list: listCreator?.rows, getName: userName },
      { key: 'designerIds', label: t(GLOBAL_CLIENT.designer), list: listDesigner?.rows, getName: userName },
      { key: 'approvedByIds', label: 'Người duyệt', list: listApprover?.rows, getName: userName }
   ]
   groups.forEach(({ key, label, list, getName }) => {
      const ids = splitIds(filter?.[key])
      if (!ids.length) return
      // So luong mau la so, hien kem chu "mau" cho de doc
      const names = key === 'count' ? ids.map((id) => `${id} mẫu`) : namesOf(ids, list, getName)
      items.push({ label, value: names.join(', ') })
   })

   if (splitIds(filter?.isPriority).length) {
      items.push({ label: t(GLOBAL_CLIENT.priorityJob), value: '✓' })
   }

   if (!items.length) return null

   return (
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4, marginTop: 8, fontSize: 13 }}>
         <span style={{ color: '#5c5c5c', marginRight: 4 }}>Đang lọc:</span>
         {items.map((item) => (
            <Tag key={item.label} color="blue" style={{ margin: 0, whiteSpace: 'normal' }}>
               <b>{item.label}:</b> {item.value}
            </Tag>
         ))}
      </div>
   )
})

export default ActiveFilterSummary
